import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCircleStop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M7.5 11.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5zm12.75.75c0 4.536-3.714 8.25-8.25 8.25S3.75 16.536 3.75 12 7.464 3.75 12 3.75s8.25 3.714 8.25 8.25"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCircleStop;
